// extracted by mini-css-extract-plugin
module.exports = {"wrapper-page":"FilterContainer_wrapper-page__1uqSq","wrapper-modal":"FilterContainer_wrapper-modal__mrFad"};